'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixCarouselSlide extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:carousel:activeSlide'];
        }

        get carousel() {
            return this._carousel || (this._carousel = this.closest('phoenix-carousel'));
        }

        get carouselStrip() {
            return this._carouselStrip || (this._carouselStrip = this.closest('phoenix-carousel-strip'));
        }

        connectedCallback() {
            super.connectedCallback();
            this.slideId = this.getAttr('slide-id', { required: true });
        }

        broadcastedEventCallback(name, args = {}) {
            const activeId = args.detail && args.detail.slide;
            if (name === 'phoenix:carousel:activeSlide' && args.target === this.carousel) {
                let isActive = this.slideId === activeId;

                if (this.carouselStrip) {
                    this.classList.toggle('is-active', isActive);
                } else {
                    this.setAttribute('aria-hidden', !isActive);
                    this.hidden = !isActive;
                }
            }
        }
    }
    window.customElements.define('phoenix-carousel-slide', PhoenixCarouselSlide);
});
